import { ButtonStyled } from './Buttons.styled';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const OrderedItemStyled = styled.div<{ light?: boolean }>(
  () => css`
    position: relative;

    > button:hover {
      opacity: 1;
    }
  `,
  ({ light, theme }) =>
    light &&
    css`
      ${BorderButtonStyled} {
        color: ${theme.colors.white};

        &:hover {
          background: ${theme.colors.clickableLight};
        }
      }
      ${MoveButtonsStyled} {
        left: calc(100% + -2.5rem);
        button {
          color: ${theme.colors.white};
        }
      }
    `
);

export const BorderButtonStyled = styled.button<{
  bottom?: boolean;
  top?: boolean;
  iconSize?: number;
  itemSpacing?: number;
}>(
  ({ theme }) => css`
    z-index: 2;

    display: block;

    padding: 0.25rem;
    overflow: hidden;

    color: ${theme.colors.clickable};
    font-size: 0;

    text-align: center;

    border-radius: 50%;

    transition: all 0.2s ease-in;

    &:hover {
      background-color: ${theme.colors.whiteHover};
    }
  `,
  ({ iconSize = 2, itemSpacing = 0, top }) =>
    top &&
    css`
      position: absolute;

      top: -${(iconSize + 0.5 + itemSpacing) / 2}rem;
      left: 50%;

      margin-left: ${(iconSize + 0.5) / -2}rem;
    `,
  ({ bottom, iconSize = 2, itemSpacing = 0 }) =>
    bottom &&
    css`
      position: absolute;

      bottom: -${(iconSize + 0.5 + itemSpacing) / 2}rem;
      left: 50%;

      margin-left: ${(iconSize + 0.5) / -2}rem;
    `
);

export const MoveButtonsStyled = styled.aside(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: calc(100% + 0.5rem);
    z-index: 2;

    display: flex;
    flex-direction: column;

    transform: translateY(-50%);

    button {
      padding: 0.25rem;

      color: ${theme.colors.clickable};

      border-radius: 50%;

      &:hover {
        background: ${theme.colors.whiteHover};
      }
    }
  `
);

export const EmptyStateStyled = styled(ButtonStyled)(
  () => css`
    border-style: dashed;
    i {
      margin-right: 1rem;
    }
  `
);
